/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoLight } from "~/foundation/Components/Logo";

export const getBritishRacingGreenColorTheme = (rtl: boolean): ColorTheme => ({
	name: "British Racing Green",
	colors: {
		ribbon: {
			bg: "themeBackgroundColors.britishRacingGreen",
			color: "primary.white",
			border: "primary.neutralGrey",
			linkColor: "primary.white"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue"
		},
		header: {
			bg: "themeBackgroundColors.britishRacingGreen",
			bgInactive: "navigationColors.darkBgTransparent",
			color: "primary.neutralGrey",
			activeColor: "primary.aramcoBlue",
			hygieneColor: "primary.neutralGrey",
			hygieneGlobalContacts: "primary.neutralGrey",
			burgerMenuColor: "primary.white",
		},
		siteNavigation: {
			gradient: "siteNavigation.darkTheme.gradient",
			bg: "siteNavigation.darkTheme.bg",
			color: "siteNavigation.darkTheme.color",
		},
		footer: {
			bg: "themeBackgroundColors.britishRacingGreen",
			color: "primary.white"
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.darkTheme.linkColor",
			activeColor: "aramcoBreadcrumb.darkTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.darkTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.darkTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.darkTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.white",
			color: "primary.text",
			linkColor: "primary.aramcoLinkBlue"
		},
		tags: {
			color: "primary.neutralGrey"
		},
		switch: {
			color: "primary.aramcoLinkBlue",
		}
	},
	Logo: () => <LogoLight height={25} />,
	FooterLogo: () => <LogoLight height={29} />
});